import { SVGProps, Ref, forwardRef } from 'react';

export const PlusCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1m-.9 16.5v-4.6H6.5v-1.8h4.6V6.5h1.8v4.6h4.6v1.8h-4.6v4.6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PlusCircleFilledSize24Glyph.displayName = 'PlusCircleFilledSize24Glyph';
